(function () {
  'use strict';

  var sizeFilterName = 'filter.p.m.custom.case_measurement_';
  var priorities = {
    availability: 0,
    collection: 1,
    movement: 2,
    'movement type': 2,
    'case measurement': 3,
    'case size': 3,
    size: 3,
    dial: 4,
    material: 5,
    gender: 6,
    price: 7
  };

  var sizeRanges = [
    { id: '19-27', label: '19-27mm', min: 0, max: 28 },
    { id: '28-29', label: '28-29mm', min: 28, max: 30 },
    { id: '30-31', label: '30-31mm', min: 30, max: 32 },
    { id: '32-33', label: '32-33mm', min: 32, max: 34 },
    { id: '34-35', label: '34-35mm', min: 34, max: 36 },
    { id: '36-37', label: '36-37mm', min: 36, max: 38 },
    { id: '38-39', label: '38-39mm', min: 38, max: 40 },
    { id: '40-41', label: '40-41mm', min: 40, max: 42 },
    { id: '42-43', label: '42-43mm', min: 42, max: 44 },
    { id: '44-45', label: '44-45mm', min: 44, max: 46 },
    { id: '46-47', label: '46-47mm', min: 46, max: 48 },
    { id: '48-plus', label: '48mm+', min: 48, max: Infinity }
  ];

  function normalizedLabel(button) {
    return (button && button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function replaceButtonText(button, nextText) {
    var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    var textNode = walker.nextNode();
    while (textNode && !textNode.textContent.trim()) textNode = walker.nextNode();
    if (textNode) textNode.textContent = nextText + ' ';
  }

  function unique(values) {
    return values.filter(function (value, index, array) { return array.indexOf(value) === index; });
  }

  function widthFromValue(value) {
    var normalized = String(value || '').trim();
    var measurementMatch = normalized.match(/\b(?:diameter|width)\s*(\d+(?:\.\d+)?)/i);
    if (measurementMatch) return Number(measurementMatch[1]);
    var leadingMatch = normalized.match(/^(\d+(?:\.\d+)?)/);
    return leadingMatch ? Number(leadingMatch[1]) : NaN;
  }

  function isGroupedFilterValue(value) {
    return /^gid:\/\/shopify\/FilterSettingGroup\//.test(String(value || ''));
  }

  function selectedSizeValues() {
    return new URL(window.location.href).searchParams.getAll(sizeFilterName);
  }

  function applySizeSelection(list) {
    var values = [];
    list.querySelectorAll('input[type="checkbox"]:checked').forEach(function (checkbox) {
      values = values.concat(checkbox.gtjSizeValues || []);
    });
    var url = new URL(window.location.href);
    url.searchParams.delete(sizeFilterName);
    unique(values).forEach(function (value) { url.searchParams.append(sizeFilterName, value); });
    url.searchParams.delete('page');
    document.documentElement.classList.add('gtj-size-filter-loading');
    window.location.assign(url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
  }

  function sizeRangeForValue(value) {
    var width = widthFromValue(value);
    return sizeRanges.find(function (range) { return width >= range.min && width < range.max; });
  }

  function hrefWithoutSizeRange(selected, range) {
    var remaining = selected.filter(function (value) { return sizeRangeForValue(value) !== range; });
    var url = new URL(window.location.href);
    url.searchParams.delete(sizeFilterName);
    unique(remaining).forEach(function (value) { url.searchParams.append(sizeFilterName, value); });
    url.searchParams.delete('page');
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }

  function enhanceActiveSizeTags() {
    var url = new URL(window.location.href);
    var selected = url.searchParams.getAll(sizeFilterName);
    if (!selected.length) return;
    if (selected.some(isGroupedFilterValue)) return;
    var selectedRanges = sizeRanges.filter(function (range) {
      return selected.some(function (value) { return sizeRangeForValue(value) === range; });
    });

    document.querySelectorAll('.tag-list--active-tags').forEach(function (list) {
      list.querySelectorAll('a[href*="' + sizeFilterName + '"]').forEach(function (link) {
        var tag = link.closest('li') || link.parentNode;
        if (tag) { tag.hidden = true; tag.classList.add('gtj-size-filter__native-active-tag'); }
      });
      list.querySelectorAll('.gtj-size-filter__active-tag').forEach(function (tag) { tag.remove(); });
      selectedRanges.forEach(function (range) {
        var item = document.createElement('li');
        item.className = 'tag tag--remove gtj-size-filter__active-tag';
        var link = document.createElement('a');
        link.className = 'btn btn--small';
        link.href = hrefWithoutSizeRange(selected, range);
        link.setAttribute('aria-label', 'Remove size ' + range.label + ' filter');
        link.appendChild(document.createTextNode(range.label));
        var remove = document.createElement('span');
        remove.className = 'gtj-size-filter__active-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        link.appendChild(remove);
        item.appendChild(link);
        list.appendChild(item);
      });
    });
  }

  function buildSizeFilter(group) {
    group.classList.add('gtj-size-filter-group');
    if (group.dataset.gtjSizeEnhanced === 'true') return;
    var nativeInputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"][name="' + sizeFilterName + '"]'));
    if (!nativeInputs.length) return;
    var nativeList = nativeInputs[0].closest('ul');
    var mount = nativeList ? nativeList.parentNode : group.querySelector('.collapsible-content__inner') || group;
    if (nativeInputs.some(function (input) { return isGroupedFilterValue(input.value); })) {
      group.classList.add('gtj-size-filter-group--native');
      if (nativeList) {
        nativeList.classList.add('gtj-size-filter');
        nativeList.setAttribute('aria-label', 'Filter watches by case size');
      }
      nativeInputs.forEach(function (input) {
        input.classList.add('gtj-size-filter__checkbox');
        var label = input.closest('label');
        if (label) label.classList.add('gtj-size-filter__label');
      });
      group.dataset.gtjSizeEnhanced = 'true';
      return;
    }
    if (nativeList) { nativeList.hidden = true; nativeList.setAttribute('aria-hidden', 'true'); nativeList.classList.add('gtj-size-filter__native'); }
    var available = unique(nativeInputs.map(function (input) { return input.value; })).filter(function (value) { return !Number.isNaN(widthFromValue(value)); });
    var selected = selectedSizeValues();
    var list = document.createElement('ul');
    list.className = 'gtj-size-filter';
    list.setAttribute('aria-label', 'Filter watches by case size');

    sizeRanges.forEach(function (range) {
      var values = available.filter(function (value) { var width = widthFromValue(value); return width >= range.min && width < range.max; });
      if (!values.length) return;
      var item = document.createElement('li');
      item.className = 'gtj-size-filter__option';
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'gtj-size-filter__checkbox';
      checkbox.id = 'gtj-size-' + range.id + '-' + Math.random().toString(36).slice(2, 8);
      checkbox.checked = values.some(function (value) { return selected.indexOf(value) !== -1; });
      checkbox.gtjSizeValues = values;
      var label = document.createElement('label');
      label.className = 'gtj-size-filter__label';
      label.htmlFor = checkbox.id;
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(range.label));
      checkbox.addEventListener('change', function (event) { event.preventDefault(); event.stopPropagation(); if (event.stopImmediatePropagation) event.stopImmediatePropagation(); applySizeSelection(list); });
      item.appendChild(label);
      list.appendChild(item);
    });
    mount.appendChild(list);
    group.dataset.gtjSizeEnhanced = 'true';
  }

  function enhanceForm(form) {
    var groups = Array.prototype.slice.call(form.children).filter(function (child) { return child.className && String(child.className).indexOf('collection-sidebar__group--') !== -1; });
    groups.forEach(function (group) {
      var button = group.querySelector('.collapsible-trigger');
      var label = normalizedLabel(button);
      if (label === 'brand' || label === 'category') { group.hidden = true; group.setAttribute('aria-hidden', 'true'); group.dataset.gtjFilterPriority = '99'; return; }
      group.hidden = false;
      group.removeAttribute('aria-hidden');
      if (label === 'case measurement' || label === 'case size') { replaceButtonText(button, 'Size'); label = 'size'; }
      if (label === 'movement type') { replaceButtonText(button, 'Movement'); label = 'movement'; }
      if (label === 'size') buildSizeFilter(group);
      group.dataset.gtjFilterPriority = String(Object.prototype.hasOwnProperty.call(priorities, label) ? priorities[label] : 50);
    });
    groups.slice().sort(function (a, b) { return Number(a.dataset.gtjFilterPriority) - Number(b.dataset.gtjFilterPriority); }).forEach(function (group) { form.appendChild(group); });
  }

  var scheduled = false;
  var observer = null;

  function observeFilters() {
    if (!observer) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function enhanceFilters() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      if (observer) observer.disconnect();
      document.querySelectorAll('.filter-form').forEach(enhanceForm);
      enhanceActiveSizeTags();
      observeFilters();
    }, 0);
  }

  function init() {
    observer = new MutationObserver(enhanceFilters);
    observeFilters();
    enhanceFilters();
    document.addEventListener('shopify:section:load', enhanceFilters);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());

/* OMEGA uses a custom collection nav rather than the reusable AI collection-nav block. */
(function () {
  'use strict';

  function installOmegaNavArrows() {
    var nav = document.querySelector('.gtj-omega-collection-nav');
    var list = nav && nav.querySelector('.gtj-omega-collection-nav__list');
    if (!nav || !list || nav.dataset.gtjArrowsInstalled === 'true') return;

    nav.dataset.gtjArrowsInstalled = 'true';
    nav.style.position = 'relative';

    var style = document.createElement('style');
    style.textContent = '@media(max-width:749px){.gtj-omega-nav-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:20;display:flex;width:32px;height:32px;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;background:#fff;color:#252525;box-shadow:0 2px 8px rgba(0,0,0,.12);opacity:0;pointer-events:none;transition:opacity .2s ease}.gtj-omega-nav-arrow.visible{opacity:1;pointer-events:auto}.gtj-omega-nav-arrow--left{left:4px}.gtj-omega-nav-arrow--right{right:4px}.gtj-omega-nav-arrow svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.gtj-omega-collection-nav__list{padding-right:48px!important}}@media(min-width:750px){.gtj-omega-nav-arrow{display:none!important}}';
    document.head.appendChild(style);

    function makeArrow(direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'gtj-omega-nav-arrow gtj-omega-nav-arrow--' + direction;
      button.setAttribute('aria-label', 'Scroll ' + direction);
      button.innerHTML = direction === 'left'
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      nav.appendChild(button);
      return button;
    }

    var left = makeArrow('left');
    var right = makeArrow('right');

    function update() {
      if (window.innerWidth > 749) return;
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      var hasOverflow = maxScroll > 4;
      left.classList.toggle('visible', hasOverflow && list.scrollLeft > 8);
      right.classList.toggle('visible', hasOverflow && list.scrollLeft < maxScroll - 8);
    }

    left.addEventListener('click', function () { list.scrollBy({ left: -200, behavior: 'smooth' }); });
    right.addEventListener('click', function () { list.scrollBy({ left: 200, behavior: 'smooth' }); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(list);
      resizeObserver.observe(nav);
    }

    update();
    requestAnimationFrame(update);
    setTimeout(update, 150);
    setTimeout(update, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installOmegaNavArrows, { once: true });
  } else {
    installOmegaNavArrows();
  }
  window.addEventListener('load', installOmegaNavArrows, { once: true });
}());
